module.exports = __webpack_public_path__ + "img/icon$.cf029f75.png";